import * as React from 'react';

var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
  return React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
};

export default FilterDropdownMenuWrapper;
//# sourceMappingURL=FilterDropdownMenuWrapper.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/table/FilterDropdownMenuWrapper.js
// module id = 833
// module chunks = 0